/**
 * Admin 사이트 > 레거시 네이밍 마켓 아이템. 라우트 admin.site.name-market-items.* 와 동기.
 * index: 드래그 정렬 + 페이지 이동 + 벌크 삭제 (AdminIndexTable facade).
 */
import { Logger } from "../../utils/Logger";
import { AdminIndexTable } from "../components/AdminIndexTable";

const CTRL_TAG = "AdminNameMarketItemController";

function noop(action: string): void {
    Logger.debug(`${CTRL_TAG}.${action} (no-op)`);
}

export const AdminNameMarketItemController = {
    index(): void {
        Logger.debug(`${CTRL_TAG}.index`);
        new AdminIndexTable({ pageSelector: ".admin-name-market-items" }).init();
    },
    create(): void { noop("create"); },
    store(): void { noop("store"); },
    edit(): void { noop("edit"); },
    update(): void { noop("update"); },
    destroy(): void { noop("destroy"); },
};
